<script>
    export let hideTop = true;
</script>

<style>
    .price-item {
        border-top: 1px solid var(--black-100);
        border-bottom: 1px solid var(--black-100);
        padding-top: 12px;
        padding-bottom: 12px;
    }

    .price-item.hide {
        border-top: unset;
    }
</style>

<div class:hide={hideTop} class="price-item"
     style="display: flex; justify-content: space-between; align-items: center">
    <div class="text-l" style="padding-right: 3px">
        <slot name="left"></slot>
    </div>
    <div class="text-l" style="padding-left: 3px; text-align: right">
        <slot name="right"></slot>
    </div>
</div>
